package io.horion.cv.components.dynamicfields

import org.jetbrains.compose.web.css.CSSNumericValue
import org.jetbrains.compose.web.css.CSSUnitLengthOrPercentage

data class DynamicField(
    val id: String,
    val label: String,
    val collapsedWidth: CSSNumericValue<out CSSUnitLengthOrPercentage>
)
